/**
 * Status bar — @capacitor/status-bar, native only.
 *
 * JAI's own chrome (AppShell.jsx's top-level background, `#FAFBFD` — the
 * same near-white every authenticated screen sits on) is light, so the
 * status bar's time/battery/signal icons need to render in DARK ink to stay
 * readable. Capacitor names this the confusing way round: `Style.Light`
 * means "dark content, for a light background" (and `Style.Dark` means the
 * opposite) — this file exists partly so nobody has to re-derive that from
 * the docs at each call site.
 *
 * `setBackgroundColor` is Android-only in Capacitor (iOS has no equivalent
 * API — the status bar is transparent over whatever the page itself paints
 * in the safe-area inset, which `index.css`'s `--safe-top` handling already
 * covers), so it's skipped here entirely rather than calling an API that
 * would just silently no-op on the one platform this app ships.
 */

import { StatusBar, Style } from '@capacitor/status-bar'
import { IS_NATIVE_APP } from './runtime'

export async function setupStatusBar() {
  if (!IS_NATIVE_APP) return
  try {
    await StatusBar.setStyle({ style: Style.Light })
  } catch (err) {
    // Cosmetic only — never worth interrupting app startup over.
    console.error('[statusBar] setStyle failed:', err)
  }
}
